import i18next from 'i18next';
import { DateFormatter, formatTime } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import TypeCol from './type';
import RecordingCol from './recording';

import type { PatientCallHistory } from 'infrastructure/classes/patient/call-history';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

export const callHistoryColumns = (): IBaseTableColumns<PatientCallHistory> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'createdAt',
      width: '120px',
      align: 'center',
      render: (value) =>
        DateFormatter({
          date: value,
          format: DateFormats['MM-dd-yy h:mm a'],
        }),
    },
    {
      label: i18next.t('labels.type'),
      key: 'type',
      width: '50px',
      align: 'center',
      render: (value) => <TypeCol type={value} />,
    },
    {
      label: i18next.t('labels.recording'),
      key: 'callId',
      render: (_, rec) => (
        <RecordingCol callGuid={rec.callId} patientGuid={rec.patientGuid} />
      ),
    },
    {
      label: i18next.t('labels.duration'),
      key: 'duration',
      width: '100px',
      align: 'center',
      render: (value) => formatTime(value),
    },
    {
      label: i18next.t('labels.electronicallySignedBy'),
      key: 'callerFullname',
      width: '200px',
    },
  ];
};
